
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { VuetifyMixin } from '../../mixins';

@Component
export default class SideNavSectionTitle extends Mixins(VuetifyMixin){
	@Prop({type: Boolean, default: false}) mini: boolean;
}
